import { useTranslation } from 'react-i18next';

import { useLocalize } from '@treams/treams-hooks/useLocalize';
import { LocalizedString } from '@treams/treams-network';

export type JobTitleNameSource = {
	title: LocalizedString;
	styrData?: { level?: number | null } | null;
};

export function useJobTitleName() {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	return (jobTitle?: JobTitleNameSource | null): string => {
		if (!jobTitle) {
			return '';
		}

		const title = localize(jobTitle.title)?.text ?? '';
		const level = jobTitle.styrData?.level;

		return level == null ? title : t('jobTitle.withStyrLevel', { title, level });
	};
}
